var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5698_789)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#DDEBFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8556 10.3229L6 20.5V25.5H33.5L17.5421 10.3253C17.3501 10.1427 17.0489 10.1416 16.8556 10.3229Z",
    fill: "#4071F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.35559 9.82288L-1.5 20V25H26L10.0421 9.82532C9.85007 9.64271 9.54892 9.64164 9.35559 9.82288Z",
    fill: "#5392F9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 8.5,
    r: 2.5,
    fill: "#5392F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5698_789"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/Photo.3ae66bbba50917f660745c35afb32758.svg";
export { ForwardRef as ReactComponent };